module.exports = __webpack_public_path__ + "img/new-link.2883c568.svg";